import { render } from "./ProductsProductPage.vue?vue&type=template&id=52e259de"
import script from "./ProductsProductPage.vue?vue&type=script&lang=js"
export * from "./ProductsProductPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__